import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ManagementApiService } from '../../../../../services';
import { UserMatrixModel } from '../../../models/user-matrix-model';
@Component({
    selector: 'app-matrix-name',
    templateUrl: './matrix-name.component.html',
    styleUrls: ['./matrix-name.component.scss'],
})
export class MatrixNameComponent implements OnInit {
    @Input() form: UntypedFormGroup;

    tooltip_position = 'above';
    loading: boolean = false;
    matrixList: UserMatrixModel[];

    constructor(
        private mgmtApi: ManagementApiService,
        private user_utlity: UserUtilityService
    ) {
        this.matrixList = [];
    }

    ngOnInit(): void {
        this.getUserMatrices();
    }

    getUserMatrices(): void {
        this.loading = true;
        this.mgmtApi
            .getMatrices(false)
            .pipe(
                finalize(() => {
                    this.loading = false;
                })
            )
            .subscribe((userMatrixList) => {
                if (userMatrixList.success === true) {
                    this.matrixList = userMatrixList.response;
                } else {
                    this.user_utlity.errorModelPopup(userMatrixList.message);
                }
            });
    }
}
